import React from 'react'
import { Icon, Popup, Button } from 'semantic-ui-react'

import db_lib from 'xAppLib/libs/db_lib';
import MedSelect from 'xAppLib/UIelems/MedSelect'


export const _BASE_CONF = {
	MEDCONS:false,
	MEDBUY:false,
	CADO:false,
	DOCCONS:false,
	SHIPPING:false,
	new_user:false
}

export const _TYPES = {
	free_script : {
		label:'Free Scripts',
		conf : {
			rule:'free',
			MEDCONS:true,
		}
	},
	free_cado : {
		label:'Free Cado',
		conf : {
			rule:'free',
			CADO:true,
		}
	},
	free_doccons : {
		label:'Free Telehealth Consultation',
		conf : {
			rule:'free',
			DOCCONS:true,
		}
	},
	free_shipping : {
		label:'Free Shipping',
		conf : {
			rule:'free',
			SHIPPING:true,
		}
	},
	percentage : {
		label:'Percentage',
		conf : {
			rule:'percentage',
			amount:0
		}
	},
	dollar : {
		label:'Dollar Amount',
		conf : {
			rule:'dollar',
			amount:0
		}
	},
	friend_referral : {
		label:'New Friend',
		conf : {
			rule:'percentage',
			amount:0,
			new_user:true,
		}
	},
	reward_referral: {
		label:'Reward for Referral',
		conf : {
			rule:'percentage',
			amount:0,
		}
	},
	org_referral: {
		label:'Paid Org Referral',
		conf : {
			rule:'percentage',
			amount:0,
		}
	}
}



const _LIST_FLDS_ADMIN = [
						{
							name: 'Num',
							jpath: 'dnum',
						},
						{
							name: 'Code',
							jpath: 'code',
						},
						{
							name: 'Enabled',
							jpath: 'enabled',
							template : ({value:enabled}) => <React.Fragment>
											<Icon name={enabled && 'check circle outline' || 'x'} color={enabled&&'green'||'red'} size='large'/>
										</React.Fragment>
						},
						{
							name: 'Type',
							jpath: 'type',
							template : ({value:type}) => <React.Fragment>
											{_TYPES[type] && _TYPES[type].label || `Unknown ${type}`}
										</React.Fragment>
						},
						{
							name: <>
									Configuration
									<Popup
									    trigger={<Button style={{marginLeft:5,transform:'scale(.7,.7)'}} icon='question' size='mini' circular/>}
									    basic
									  >
									  <Popup.Header>Legend</Popup.Header>
									    <Popup.Content>
											<Icon name="shopping basket" /> Medbuy<br/>
											<Icon name="mobile" /> Medcons<br/>
											<Icon name="doctor" /> Doccons<br/>
											<Icon name="call" /> Call a doctor<br/>
											<Icon name="truck" /> Shipping<br/>
											<Icon name="user plus" /> For New users<br/>
											<Icon name="user circle"  /> Restricted to a user<br/>
									    </Popup.Content>
								  </Popup>
								</>,
							jpath: 'conf',
							template : ({value:conf,row}) => {
								const { type } = row
								const { MEDCONS,MEDBUY,CADO,SHIPPING,DOCCONS,new_user, rule,amount} = conf
								return <React.Fragment>
												{(_=>{
													switch (rule) {
														case 'dollar':
															return `$${amount}`
														case 'percentage':
															return `${amount}%`
														case 'free':
															return `FREE`
													}
														
												})()}<br/>
												<Icon name="shopping basket" disabled={!MEDBUY} />
												<Icon name="mobile" disabled={!MEDCONS} />
												<Icon name="call" disabled={!CADO} />
												<Icon name="truck" disabled={!SHIPPING} />
												<Icon name="doctor" disabled={!DOCCONS} />
												<Icon name="user plus" disabled={!new_user}/>
												<Icon name="user circle" disabled={!row?.users?.email} />
											</React.Fragment>
							}
						},
						{
							name: 'Expiry',
							jpath: 'expiry_date',
							type:'date'
						},
						{
							name: 'Recipient',
							jpath: 'users',
							template : ({value:users}) => <React.Fragment>
											{users?.email}
										</React.Fragment>
						},

						{
							name: 'Usage',
							type: 'compound',
							parts: [
								{
									name: 'max_use',
									jpath: 'max_use'
								},
								{
									name: 'used',
									jpath: 'used'
								},
								{
									name: 'max_use_user',
									jpath: 'max_use_user'
								},
							],
							template : ({max_use,used,max_use_user}) => <React.Fragment>
											{max_use !== null && `${used||0}/${max_use}` || '∞'}
											{max_use !== null && max_use_user && <React.Fragment>/<Icon size='small' name='user'/></React.Fragment>}
										</React.Fragment>
						},


					];
					
const _LIST_FLDS_ORG = [
						{
							name: 'Code',
							jpath: 'code',
						},
						
						{
							name: 'Recipient',
							jpath: 'users',
							template : ({value:users}) => <React.Fragment>
											{users?.email}
										</React.Fragment>
						},

						{
							name: 'Usage',
							type: 'compound',
							parts: [
								{
									name: 'max_use',
									jpath: 'max_use'
								},
								{
									name: 'used',
									jpath: 'used'
								},
							],
							template : ({max_use,used}) => <React.Fragment>
											{max_use && `${used||0}/${max_use}` || '∞'}
										</React.Fragment>
						},


					];
					

					
const _EDIT_FLDS_ADMIN = [
						{
							label: 'Code',
							name: 'code',
							type: 'text',
							placeholder:"Leave blank to auto generate code",
							valid_not_required:true
						},
						{
							label: 'Enabled',
							name: 'enabled',
							type: 'bool',
						},
						{
							label:'Type',
							name: 'type',
							type:'select',
							options:Object.keys(_TYPES).map(t=>({key:t,value:t,text:_TYPES[t].label}))
						},
						{
							label: 'Expiry',
							name: 'expiry_date',
							type:'date',
							valid_not_required:true
							
						},
						{
							label: 'Max Use',
							name: 'max_use',
							valid_not_required:true
						},
						{
							label: 'Max Use is per user',
							name: 'max_use_user',
							type:'bool'
						},
						{
							label: 'Recipient (email)',
							name: 'users',
							valid_not_required:true
						},
						{
							label: 'Min Age',
							name: 'min_age',
							valid_not_required:true
						},
						{
							label: 'Max Age',
							name: 'max_age',
							valid_not_required:true
						},
						{
							name: 'meds',
							label: 'Meds Select',
							type: MedSelect,
							valid_not_required: true,
						},
						{
							name: 'conf',
							label: 'Config',
							type: 'json',
						},

					];
					
const _EDIT_FLDS_ORG = [
						{
							label: 'Recipient (email)',
							name: 'users',
						},

					];





const _MODEL_NAME = 'discounts_model';

const _USE_DATA = 'API'
const _API_NAME = 'discounts'


// ---- --------------------------------------------  --------------------------------------------  
// ---- --------------------------------------------  --------------------------------------------  

export default class discounts_model extends db_lib {

	static get LIST_FLDS_ADMIN() { return _LIST_FLDS_ADMIN; }
	static get LIST_FLDS_ORG() { return _LIST_FLDS_ORG; }
	static get EDIT_FLDS_ADMIN() { return _EDIT_FLDS_ADMIN; }
	static get EDIT_FLDS_ORG() { return _EDIT_FLDS_ORG; }
	static get BASE_CONF() { return _BASE_CONF; }
	static get TYPES() { return _TYPES; }
	static get MODEL_NAME() { return _MODEL_NAME; }
	static get USE_DATA() { return _USE_DATA; }
	static get API_NAME() { return _API_NAME; }



	// ----	--------------------------------------------	--------------------------------------------
	// ----	--------------------------------------------	--------------------------------------------

	
	static async load_discounts (data) {

		console.log('discounts_model :: load_discounts sending ', data);

		return await discounts_model.get_record(null, null, {act:'discounts_list', ...data});


	}
	
	
		// ---- --------------------------------------------  --------------------------------------------
		// ---- --------------------------------------------  --------------------------------------------
		
		static async delete_discount(did) { 
			const res = await discounts_model.get_record(null, null, {act:'del', did});
			return res
		}
		
			
		// ---- --------------------------------------------  --------------------------------------------
		// ---- --------------------------------------------  --------------------------------------------
		
		static async get_discount_by_code(code) { 
			const res = await discounts_model.get_record(null, null, {act:'from_code', code});
			return res
		}
		
		// ---- --------------------------------------------  --------------------------------------------
		// ---- --------------------------------------------  --------------------------------------------
		
		static async get_referral_code(create = false) { 
			const res = await discounts_model.get_record(null, null, {act:'referral_code', create});
			return res
		}
		
		// ---- --------------------------------------------  --------------------------------------------
		// ---- --------------------------------------------  --------------------------------------------
		
		static async get_org_referral_code(target_email, create = false) { 
			const res = await discounts_model.get_record(null, null, {act:'org_referral_code', target_email, create});
			return res
		}
	
		// ---- --------------------------------------------  --------------------------------------------
		// ---- --------------------------------------------  --------------------------------------------

		static async save_discount( did, d, ca ) {
			if (!d.conf)
				d.conf = {}
			let res
			if (did) {
				res = await discounts_model.get_record(null, null, {act:'upd', did, data:{...d}});
			} else {
				res = await discounts_model.get_record(null, null, { act:'add', data:{...d} } );
			}
			console.log({res});
			ca && ca(res)
		}
}
